export default {
  install(Vue) {
    const LAST_VIEW_TODAY = "LAST_VIEW_TODAY";
    const LAST_VIEW_TODAY_RECORD = "LAST_VIEW_TODAY_RECORD";
    const LAST_VIEW_TODAY_CHECKIN = "LAST_VIEW_TODAY_CHECKIN";
    const LAST_VIEW_TODAY_EXAM = "LAST_VIEW_TODAY_EXAM";
    const LAST_VIEW_TODAY_DISPENSE = "LAST_VIEW_TODAY_DISPENSE";
    const LAST_VIEW_TODAY_CHECKOUT = "LAST_VIEW_TODAY_CHECKOUT";
    const LAST_VIEW_TODAY_CHECK_DATA = "LAST_VIEW_TODAY_CHECK_DATA";
    const LAST_VIEW_TODAY_CHECK_BOOKING = "LAST_VIEW_TODAY_CHECK_BOOKING";

    const LAST_VIEW_SCHEDULE = "LAST_VIEW_SCHEDULE";

    const LAST_VIEW_OVERVIEW = "LAST_VIEW_OVERVIEW";
    const LAST_VIEW_OVERVIEW_BOOKING = "LAST_VIEW_OVERVIEW_BOOKING";
    const LAST_VIEW_OVERVIEW_ALL = "LAST_VIEW_OVERVIEW_ALL";
    const LAST_VIEW_OVERVIEW_CHECK_IN = "LAST_VIEW_OVERVIEW_CHECK_IN";
    const LAST_VIEW_OVERVIEW_INSPECTED = "LAST_VIEW_OVERVIEW_INSPECTED";
    const LAST_VIEW_OVERVIEW_DISPENSED = "LAST_VIEW_OVERVIEW_DISPENSED";
    const LAST_VIEW_OVERVIEW_CHECK_OUT = "LAST_VIEW_OVERVIEW_CHECK_OUT";

    const LAST_VIEW_WAITING = "LAST_VIEW_WAITING";
    const LAST_VIEW_WAITING_ALL = "LAST_VIEW_WAITING_ALL";
    const LAST_VIEW_WAITING_MY = "LAST_VIEW_WAITING_MY";

    const LAST_VIEW_TODO = "LAST_VIEW_TODO";
    const LAST_VIEW_TODO_EXAM = "LAST_VIEW_TODO_EXAM";
    const LAST_VIEW_TODO_OUTSOURCING = "LAST_VIEW_TODO_OUTSOURCING";
    const LAST_VIEW_TODO_INSIDE = "LAST_VIEW_TODO_INSIDE";
    const LAST_VIEW_TODO_DRUG = "LAST_VIEW_TODO_DRUG";
    const LAST_VIEW_TODO_IN_HOSPITAL = "LAST_VIEW_TODO_IN_HOSPITAL";
    const LAST_VIEW_TODO_VERIFY = "LAST_VIEW_TODO_VERIFY";
    const LAST_VIEW_CONFIRM_VERIFY = "LAST_VIEW_CONFIRM_VERIFY";
    const LAST_VIEW_CANCEL_VERIFY = "LAST_VIEW_CANCEL_VERIFY";
    const LAST_VIEW_ARCHIVED_EXAM = "LAST_VIEW_ARCHIVED_EXAM";
    const LAST_VIEW_NOT_ARCHIVED_EXAM = "LAST_VIEW_NOT_ARCHIVED_EXAM";

    const LAST_VIEW_CHECK_OUT = "LAST_VIEW_CHECK_OUT";
    const LAST_VIEW_CHECK_OUT_UNDO = "LAST_VIEW_CHECK_OUT_UNDO";
    const LAST_VIEW_CHECK_OUT_FINISH = "LAST_VIEW_CHECK_OUT_FINISH";

    Vue.prototype.$lastView = {
      //reset==================================================================
      reset() {
        localStorage.removeItem(LAST_VIEW_TODAY);
        localStorage.removeItem(LAST_VIEW_TODAY_RECORD);
        localStorage.removeItem(LAST_VIEW_TODAY_CHECKIN);
        localStorage.removeItem(LAST_VIEW_TODAY_EXAM);
        localStorage.removeItem(LAST_VIEW_TODAY_DISPENSE);
        localStorage.removeItem(LAST_VIEW_TODAY_CHECKOUT);
        localStorage.removeItem(LAST_VIEW_TODAY_CHECK_DATA);
        localStorage.removeItem(LAST_VIEW_TODAY_CHECK_BOOKING);

        localStorage.removeItem(LAST_VIEW_SCHEDULE);

        localStorage.removeItem(LAST_VIEW_OVERVIEW);
        localStorage.removeItem(LAST_VIEW_OVERVIEW_BOOKING);
        localStorage.removeItem(LAST_VIEW_OVERVIEW_ALL);
        localStorage.removeItem(LAST_VIEW_OVERVIEW_CHECK_IN);
        localStorage.removeItem(LAST_VIEW_OVERVIEW_INSPECTED);
        localStorage.removeItem(LAST_VIEW_OVERVIEW_DISPENSED);
        localStorage.removeItem(LAST_VIEW_OVERVIEW_CHECK_OUT);

        localStorage.removeItem(LAST_VIEW_WAITING);
        localStorage.removeItem(LAST_VIEW_WAITING_ALL);
        localStorage.removeItem(LAST_VIEW_WAITING_MY);

        localStorage.removeItem(LAST_VIEW_TODO);
        localStorage.removeItem(LAST_VIEW_TODO_EXAM);
        localStorage.removeItem(LAST_VIEW_TODO_OUTSOURCING);
        localStorage.removeItem(LAST_VIEW_TODO_INSIDE);
        localStorage.removeItem(LAST_VIEW_TODO_DRUG);
        localStorage.removeItem(LAST_VIEW_TODO_IN_HOSPITAL);
        localStorage.removeItem(LAST_VIEW_TODO_VERIFY);
        localStorage.removeItem(LAST_VIEW_CONFIRM_VERIFY);
        localStorage.removeItem(LAST_VIEW_CANCEL_VERIFY);
        localStorage.removeItem(LAST_VIEW_ARCHIVED_EXAM);
        localStorage.removeItem(LAST_VIEW_NOT_ARCHIVED_EXAM);

        localStorage.removeItem(LAST_VIEW_CHECK_OUT);
        localStorage.removeItem(LAST_VIEW_CHECK_OUT_UNDO);
        localStorage.removeItem(LAST_VIEW_CHECK_OUT_FINISH);
      },
      //today-todo==========================================================
      setToday(timestamp) {
        localStorage.setItem(LAST_VIEW_TODAY, timestamp);
      },
      getToday() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODAY) || 0);
      },
      setTodayRecord(timestamp) {
        localStorage.setItem(LAST_VIEW_TODAY_RECORD, timestamp);
      },
      getTodayRecord() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODAY_RECORD) || 0);
      },
      setTodayCheckin(timestamp) {
        localStorage.setItem(LAST_VIEW_TODAY_CHECKIN, timestamp);
      },
      getTodayCheckin() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODAY_CHECKIN) || 0);
      },
      setTodayExam(timestamp) {
        localStorage.setItem(LAST_VIEW_TODAY_EXAM, timestamp);
      },
      getTodayExam() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODAY_EXAM) || 0);
      },
      setTodayDispense(timestamp) {
        localStorage.setItem(LAST_VIEW_TODAY_DISPENSE, timestamp);
      },
      getTodayDispense() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODAY_DISPENSE) || 0);
      },
      setTodayCheckout(timestamp) {
        localStorage.setItem(LAST_VIEW_TODAY_CHECKOUT, timestamp);
      },
      getTodayCheckout() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODAY_CHECKOUT) || 0);
      },
      setTodayCheckData(timestamp) {
        localStorage.setItem(LAST_VIEW_TODAY_CHECK_DATA, timestamp);
      },
      getTodayCheckData() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODAY_CHECK_DATA) || 0);
      },
      setTodayCheckBooking(timestamp) {
        localStorage.setItem(LAST_VIEW_TODAY_CHECK_BOOKING, timestamp);
      },
      getTodayCheckBooking() {
        return parseInt(
          localStorage.getItem(LAST_VIEW_TODAY_CHECK_BOOKING) || 0
        );
      },
      //=======================================================================
      setSchedule(timestamp) {
        localStorage.setItem(LAST_VIEW_SCHEDULE, timestamp);
      },
      getSchedule() {
        return parseInt(localStorage.getItem(LAST_VIEW_SCHEDULE) || 0);
      },
      //schedule-overview=======================================================
      setOverview(timestamp) {
        localStorage.setItem(LAST_VIEW_OVERVIEW, timestamp);
      },
      getOverview() {
        return parseInt(localStorage.getItem(LAST_VIEW_OVERVIEW) || 0);
      },

      setOverviewBooking(timestamp) {
        localStorage.setItem(LAST_VIEW_OVERVIEW_BOOKING, timestamp);
      },
      getOverviewBooking() {
        return parseInt(localStorage.getItem(LAST_VIEW_OVERVIEW_BOOKING) || 0);
      },
      setOverviewAll(timestamp) {
        localStorage.setItem(LAST_VIEW_OVERVIEW_ALL, timestamp);
      },
      getOverviewAll() {
        return parseInt(localStorage.getItem(LAST_VIEW_OVERVIEW_ALL) || 0);
      },
      setOverviewCheckIn(timestamp) {
        localStorage.setItem(LAST_VIEW_OVERVIEW_CHECK_IN, timestamp);
      },
      getOverviewCheckIn() {
        return parseInt(localStorage.getItem(LAST_VIEW_OVERVIEW_CHECK_IN) || 0);
      },
      setOverviewInspected(timestamp) {
        localStorage.setItem(LAST_VIEW_OVERVIEW_INSPECTED, timestamp);
      },
      getOverviewInspected() {
        return parseInt(
          localStorage.getItem(LAST_VIEW_OVERVIEW_INSPECTED) || 0
        );
      },
      setOverviewDispensed(timestamp) {
        localStorage.setItem(LAST_VIEW_OVERVIEW_DISPENSED, timestamp);
      },
      getOverviewDispensed() {
        return parseInt(
          localStorage.getItem(LAST_VIEW_OVERVIEW_DISPENSED) || 0
        );
      },
      setOverviewCheckOut(timestamp) {
        localStorage.setItem(LAST_VIEW_OVERVIEW_CHECK_OUT, timestamp);
      },
      getOverviewCheckOut() {
        return parseInt(
          localStorage.getItem(LAST_VIEW_OVERVIEW_CHECK_OUT) || 0
        );
      },

      //schedule-waiting=======================================================
      setWaiting(timestamp) {
        localStorage.setItem(LAST_VIEW_WAITING, timestamp);
      },
      getWaiting() {
        return parseInt(localStorage.getItem(LAST_VIEW_WAITING) || 0);
      },
      setWaitingAll(timestamp) {
        localStorage.setItem(LAST_VIEW_WAITING_ALL, timestamp);
      },
      getWaitingAll() {
        return parseInt(localStorage.getItem(LAST_VIEW_WAITING_ALL) || 0);
      },
      setWaitingMy(timestamp) {
        localStorage.setItem(LAST_VIEW_WAITING_MY, timestamp);
      },
      getWaitingMy() {
        return parseInt(localStorage.getItem(LAST_VIEW_WAITING_MY) || 0);
      },
      //schedule-todo=======================================================
      setTodo(timestamp) {
        localStorage.setItem(LAST_VIEW_TODO, timestamp);
      },
      getTodo() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODO) || 0);
      },

      setTodoExam(timestamp) {
        localStorage.setItem(LAST_VIEW_TODO_EXAM, timestamp);
      },
      getTodoExam() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODO_EXAM) || 0);
      },
      setTodoOutsourcing(timestamp) {
        localStorage.setItem(LAST_VIEW_TODO_OUTSOURCING, timestamp);
      },
      getTodoOutsourcing() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODO_OUTSOURCING) || 0);
      },
      setTodoInside(timestamp) {
        localStorage.setItem(LAST_VIEW_TODO_INSIDE, timestamp);
      },
      getTodoInside() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODO_INSIDE) || 0);
      },
      setTodoDrug(timestamp) {
        localStorage.setItem(LAST_VIEW_TODO_DRUG, timestamp);
      },
      getTodoDrug() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODO_DRUG) || 0);
      },
      setTodoInHospital(timestamp) {
        localStorage.setItem(LAST_VIEW_TODO_IN_HOSPITAL, timestamp);
      },
      getTodoInHospital() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODO_IN_HOSPITAL) || 0);
      },
      setTodoVerify(timestamp) {
        localStorage.setItem(LAST_VIEW_TODO_VERIFY, timestamp);
      },
      getTodoVerify() {
        return parseInt(localStorage.getItem(LAST_VIEW_TODO_VERIFY) || 0);
      },
      setConfirmVerify(timestamp) {
        localStorage.setItem(LAST_VIEW_CONFIRM_VERIFY, timestamp);
      },
      getConfirmVerify() {
        return parseInt(localStorage.getItem(LAST_VIEW_CONFIRM_VERIFY) || 0);
      },
      setCancelVerify(timestamp) {
        localStorage.setItem(LAST_VIEW_CANCEL_VERIFY, timestamp);
      },
      getCancelVerify() {
        return parseInt(localStorage.getItem(LAST_VIEW_CANCEL_VERIFY) || 0);
      },
      setArchivedExam(timestamp) {
        localStorage.setItem(LAST_VIEW_ARCHIVED_EXAM, timestamp);
      },
      getArchivedExam() {
        return parseInt(localStorage.getItem(LAST_VIEW_ARCHIVED_EXAM) || 0);
      },
      setNotArchivedExam(timestamp) {
        localStorage.setItem(LAST_VIEW_NOT_ARCHIVED_EXAM, timestamp);
      },
      getNotArchivedExam() {
        return parseInt(localStorage.getItem(LAST_VIEW_NOT_ARCHIVED_EXAM) || 0);
      },
      //checkout===========================================================
      setCheckOut(timestamp) {
        localStorage.setItem(LAST_VIEW_CHECK_OUT, timestamp);
      },
      getCheckOut() {
        return parseInt(localStorage.getItem(LAST_VIEW_CHECK_OUT) || 0);
      },
      setCheckOutUndo(timestamp) {
        localStorage.setItem(LAST_VIEW_CHECK_OUT_UNDO, timestamp);
      },
      getCheckOutUndo() {
        return parseInt(localStorage.getItem(LAST_VIEW_CHECK_OUT_UNDO) || 0);
      },
      setCheckOutFinish(timestamp) {
        localStorage.setItem(LAST_VIEW_CHECK_OUT_FINISH, timestamp);
      },
      getCheckOutFinish() {
        return parseInt(localStorage.getItem(LAST_VIEW_CHECK_OUT_FINISH) || 0);
      },
    };
  },
};
